import { render, staticRenderFns } from "./Unilateral-turn.vue?vue&type=template&id=29d83121&scoped=true&"
import script from "./Unilateral-turn.vue?vue&type=script&lang=js&"
export * from "./Unilateral-turn.vue?vue&type=script&lang=js&"
import style0 from "./Unilateral-turn.vue?vue&type=style&index=0&id=29d83121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d83121",
  null
  
)

export default component.exports